module.exports = __webpack_public_path__ + "static/4-the-rules-ca9d493d008569974f4657df4709aa1f.png";